export const getNoCache = (): string => {
  const date: Date = new Date();
  const rand: Number = Math.round(Math.random() * 99999);
  return String(date.getTime()) + String(rand);
};
